import MainSkills from "../../components/Forms/MainSkills";
import BasicCard from "../BasicCard";
import Dummylayout from "../Dummylayout";

function SkillsForms() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <MainSkills/>
            </BasicCard>
        </>
    )
}
export default SkillsForms;